const LANGUAGE_TO_COUNTRY_CODE: Record<string, string> = {
  ar: 'SA',
  arabic: 'SA',
  de: 'DE',
  german: 'DE',
  en: 'US',
  english: 'US',
  es: 'ES',
  spanish: 'ES',
  fr: 'FR',
  french: 'FR',
  hi: 'IN',
  hindi: 'IN',
  it: 'IT',
  italian: 'IT',
  ja: 'JP',
  japanese: 'JP',
  ko: 'KR',
  korean: 'KR',
  nl: 'NL',
  dutch: 'NL',
  pt: 'PT',
  portuguese: 'PT',
  ru: 'RU',
  russian: 'RU',
  th: 'TH',
  thai: 'TH',
  tr: 'TR',
  turkish: 'TR',
  uk: 'UA',
  ukrainian: 'UA',
  zh: 'CN',
  chinese: 'CN',
};

function toFlagEmoji(countryCode: string) {
  return String.fromCodePoint(
    ...countryCode
      .toUpperCase()
      .split('')
      .map(character => 127397 + character.charCodeAt(0))
  );
}

function resolveCountryCode(language: string) {
  const normalizedLanguage = language.trim();
  const uppercaseLanguage = normalizedLanguage.toUpperCase();

  const localeMatch = uppercaseLanguage.match(/\b[A-Z]{2,3}[-_]([A-Z]{2})\b/);
  if (localeMatch) {
    return localeMatch[1];
  }

  const parenthesizedCountryMatch = uppercaseLanguage.match(/\(([A-Z]{2})\)/);
  if (parenthesizedCountryMatch) {
    return parenthesizedCountryMatch[1];
  }

  const languageCode = normalizedLanguage.toLowerCase().split(/[-_\s(]/)[0];
  return LANGUAGE_TO_COUNTRY_CODE[languageCode] ?? null;
}

export function formatVoiceGender(gender: string) {
  if (!gender) {
    return 'Unknown';
  }

  return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
}

export function getVoiceLanguageFlag(language: string) {
  const countryCode = resolveCountryCode(language);

  if (!countryCode || countryCode.length !== 2) {
    return '🌐';
  }

  return toFlagEmoji(countryCode);
}
